import React from 'react';
import { ReactComponent as Dashboard } from '../../assets/Dashboard.svg';
import { ReactComponent as Subadmin } from '../../assets/Subadmin.svg';
import { ReactComponent as Login } from '../../assets/Login.svg';
import { ReactComponent as Password } from '../../assets/Password.svg';
import { ReactComponent as IDP } from '../../assets/IdentityProvider.svg';
import { ReactComponent as Application } from '../../assets/Application.svg';
import { ReactComponent as User } from '../../assets/User.svg';
import { ReactComponent as Group } from '../../assets/Group.svg';
import { ReactComponent as APIKey } from '../../assets/APIKey.svg';
import { ReactComponent as Certificate } from '../../assets/Certificate.svg';
import { ReactComponent as Email } from '../../assets/Email.svg';
import { ReactComponent as Logs } from '../../assets/Log.svg';

export const getSidebarItems = (subadmin, theme) => {
  if (subadmin) {
    return [
      {
        label: 'Application',
        icon: <Application style={{ color: theme.palette.primary.main }} />,
        path: '/application-setting',
      },
      {
        label: 'Users',
        icon: <User style={{ color: theme.palette.primary.main }} />,
        path: '/user-setting',
      },
      {
        label: 'Groups',
        icon: <Group style={{ color: theme.palette.primary.main }} />,
        path: '/group-setting',
      },
      {
        label: 'Logs',
        icon: <Logs style={{ color: theme.palette.primary.main }} />,
        path: '/logs',
      },
    ];
  }

  return [
    {
      label: 'Dashboard',
      icon: <Dashboard style={{ color: theme.palette.primary.main }} />,
      path: '/dashboard',
    },
    {
      label: 'Sub-Admins',
      icon: <Subadmin style={{ color: theme.palette.primary.main }} />,
      path: '/subadmin',
    },
    {
      label: 'Organization Settings',
    },
    {
      label: 'Login',
      icon: <Login style={{ color: theme.palette.primary.main }} />,
      path: '/login-setting',
    },
    {
      label: 'Password',
      icon: <Password style={{ color: theme.palette.primary.main }} />,
      path: '/password-setting',
    },
    {
      label: 'Identity Provider',
      icon: <IDP style={{ color: theme.palette.primary.main }} />,
      path: '/idp-setting',
    },
    {
      label: 'Application',
      icon: <Application style={{ color: theme.palette.primary.main }} />,
      path: '/application-setting',
    },
    {
      label: 'Users',
      icon: <User style={{ color: theme.palette.primary.main }} />,
      path: '/user-setting',
    },
    {
      label: 'Groups',
      icon: <Group style={{ color: theme.palette.primary.main }} />,
      path: '/group-setting',
    },
    {
      label: 'API Key',
      icon: <APIKey style={{ color: theme.palette.primary.main }} />,
      path: '/apikey-setting',
    },
    {
      label: 'Certificate',
      icon: <Certificate style={{ color: theme.palette.primary.main }} />,
      path: '/certificate-setting',
    },
    {
      label: 'Email',
      icon: <Email style={{ color: theme.palette.primary.main }} />,
      path: '/email-setting',
    },
    {
      label: 'Logs',
      icon: <Logs style={{ color: theme.palette.primary.main }} />,
      path: '/logs',
    },
  ];
};
